angular
    .module('tradersyard')
    .run([
        'graph-api-client',
        'graph-notification-factory',
        function ($api, $factory) {
            $api.factory.notification = $factory;
        },
    ])
    .factory('graph-notification-factory', [
        'graph-api-client',
        function (client) {
            return {
                query: function (userId, options) {
                    return client.get([userId, 'notifications'], options);
                },
                read: function (userId, feedItemId, options) {
                    return client.get([userId, 'notification', feedItemId], options);
                },
                unread: function (userId, options) {
                    return client.get([userId, 'notification', 'unread'], options);
                },
                readSettings: function (userId, options) {
                    return client.get([userId, 'notification-settings'], options);
                },
                enableSettingKey: function (userId, settingKey, settingType, options) {
                    return client.put([userId, 'notification-settings', settingKey, settingType], options);
                },
                disableSettingKey: function (userId, settingKey, settingType, options) {
                    return client.delete([userId, 'notification-settings', settingKey, settingType], options);
                },
                markAsRead: function (userId, feedItemId, options) {
                    return client.put([userId, 'notification', feedItemId, 'unread'], options);
                },
                markAllAsRead: function (userId, options) {
                    return client.put([userId, 'notifications', 'unread'], options);
                },
            };
        },
    ]);
